import {validateRegexPath} from '@github-ui/paths'
import {requestServerValidation} from './use-async-validation'

export const validateRegexPattern = async (pattern?: string): Promise<boolean> => {
  if (!pattern?.length) {
    return true
  }

  return await requestServerValidation({pattern}, `${validateRegexPath()}/pattern`)
}
